<template>
    <div>
        <md-dialog :md-fullscreen="false"
                   :md-active.sync="showDialog">
            <md-dialog-content>
                <md-empty-state
                        class="md-primary"
                        md-icon="check"
                        md-label="Upload Complete!"
                        md-description="Please give us a few moments to process your video. It should be viewable in 5 minutes.">
                    <md-button to="/" class="md-primary md-raised">OK</md-button>
                </md-empty-state>
            </md-dialog-content>
        </md-dialog>
    </div>
</template>

<script>
    export default {
        name: "success-alert",
        props: ['showDialog']
    }
</script>

<style scoped>

</style>